import * as yup from "yup";

export const ForWhomMainPageSchema = yup.object().shape({
  bookingType: yup.string("Enter Booking type").required("Booking type is required").nullable(),
  bookingFor: yup
    .array()
    .of(
      yup.object({
        value: yup.string("Enter Booking for").required("Booking for is required"),
      })
    )
    .required("Booking for is required")
    .nullable(),
  redPandaProjects: yup
    .array()
    .of(yup.object())
    .nullable()
    .test("pred-user-project-required", "Project is required",
      function (value) {
        const { isPredUser, project } = this.parent;
        if (!isPredUser) return true;
        const hasRedPanda =
          Array.isArray(value) && value.length > 0;
        const hasManual =
          typeof project === "string" && project.trim().length > 0;
        return hasRedPanda || hasManual;
      }
    )
    .test("max-10-projects", "You can select up to 10 projects",
      function (value) {
        if (!Array.isArray(value)) return true;
        return value.length <= 10;
      }
    ),
  project: yup
    .string("Enter project")
    .nullable()
    .notRequired(),
  description: yup.string("Enter description").typeError("Invalid type").when("isPredUser", {
    is: true,
    then: (schema) =>
      schema
        .nullable(),
    otherwise: (schema) => schema.required("Description is required"),
  }),
  hasHazardousMaterials: yup.boolean().nullable(),
  hazardousMaterialsText: yup.string().when(["hasHazardousMaterials", "bookingType"], {
    is: (hasHazardousMaterials, bookingType) => hasHazardousMaterials && bookingType === "Run",
    then: yup.string().required("Please list hazardous materials or confirm you are not bringing any"),
    otherwise: yup.string(),
  }),
  withAssistance: yup.boolean().default(false),
  assistanceReason: yup
    .string()
    .transform(v => (typeof v === "string" ? v.trim() : v))
    .when(["withAssistance", "bookingType"], {
      is: (withAssistance, bookingType) => withAssistance && bookingType === "Run",
      then: schema => {
        // For now we don't require assistance reason
        // return schema.required("Reason for assistance is required");
        return schema.notRequired();
      },
      otherwise: schema => schema.notRequired(),
    }),
});
